/**
 * This is a display component for thumbnails.  It supports locking and
 * unlocking for the SwagProgress but can be used as a generic layout component
 * as well
 **/
import {t} from "@lingui/core/macro";
import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {mediaQueries} from "@khan/shared-styles";
import {staticUrl} from "@khan/urls";

// eslint-disable-next-line no-restricted-imports -- TODO: Replace this component with the equivalent one from Wonder Blocks.
import DeprecatedIcon from "#shared-styles-package/deprecated-icon.tsx";

import sharedStyles from "./styles.ts";

const imgRoot = "/images/referrals";

const unlockAlt = {
    path: "M68.799 49.989q2.622 0 4.446 1.824t1.824 4.446l0 37.506q0 2.622-1.824 4.446t-4.446 1.824l-62.529 0q-2.622 0-4.446-1.824t-1.824-4.446l0-37.506q0-2.622 1.824-4.446t4.446-1.824l2.052 0l0-20.805q0-12.027 8.55-20.577t20.634-8.607q12.084 0 20.634 8.55t8.55 20.634q0 1.653-1.254 2.907t-2.907 1.254l-4.161 0q-1.71 0-2.964-1.254t-1.197-2.907q0-6.897-4.902-11.799t-11.799-4.902-11.799 4.902-4.845 11.799l0 20.805l47.937 0z",
    width: 75.043,
    height: 100,
} as const;

class ThumbnailBlock extends React.Component<{
    isIntro?: boolean;
    imgPath: string;
    assetName?: string;
    locked?: boolean;
    children?: any;
    shade: {
        backgroundColor: string;
        opacity: number;
    };
}> {
    static defaultProps: {
        assetName: string;
        isIntro: boolean;
        locked: boolean;
        shade: {
            backgroundColor: string;
            opacity: number;
        };
    } = {
        isIntro: true,
        locked: false,
        shade: {
            backgroundColor: "#000000",
            opacity: 0,
        },
        assetName: "",
    };

    render(): React.ReactNode {
        const {isIntro, locked, imgPath, assetName, children, shade} =
            this.props;

        return (
            <div className={css(styles.thumbnailContainer)}>
                <div className={css(styles.imageContainer)}>
                    <img
                        alt=""
                        aria-hidden={true}
                        className={css(styles.ambassadorImg)}
                        src={staticUrl(`${imgRoot}/${imgPath}`)}
                    />
                    {!isIntro && (
                        <div>
                            <div
                                className={css(styles.shadeOverlay)}
                                style={shade}
                            />
                            <div
                                className={css(
                                    styles.shadeOverlay,
                                    styles.shadeContent,
                                )}
                            >
                                {locked && (
                                    <img
                                        alt=""
                                        aria-hidden={true}
                                        className={css(styles.lockedIcon)}
                                        src={staticUrl(`${imgRoot}/locked.svg`)}
                                    />
                                )}

                                {!locked && (
                                    <DeprecatedIcon
                                        icon={unlockAlt}
                                        size={32}
                                    />
                                )}

                                <div className={css(styles.shadeText)}>
                                    {assetName}
                                    {!locked && (
                                        <span>
                                            {": "}
                                            {t`Unlocked`}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                {children}
            </div>
        );
    }
}

const styles = StyleSheet.create({
    ...sharedStyles,
    thumbnailContainer: {
        flex: "1 1 0%",
        justifyContent: "space-between",
        flexWrap: "wrap",
        overflow: "hidden",
        fontSize: 16,

        [mediaQueries.xl]: {
            marginLeft: "1em",
        },
        [mediaQueries.smOrSmaller]: {
            marginLeft: "1em",
            marginTop: 20,
        },
    },
    imageContainer: {
        position: "relative",
        color: "white",
    },
    ambassadorImg: {
        width: "100%",
        maxHeight: 120,
    },
    shadeOverlay: {
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 5,
        right: 0,
        verticalAlign: "middle",
        textAlign: "center",
        paddingTop: "4em",
    },
    shadeContent: {
        marginTop: "-1em",
    },
    shadeText: {
        fontSize: "32px",
        fontWeight: "bold",
    },
    lockedIcon: {
        width: 52,
        margin: "-16px 0px -8px 0px",
    },
});

export default ThumbnailBlock;
